import {PurchaseOrderSummaryModel} from './purchaseOrderSummary.model';
import {SaleSummaryModel} from '../../../../api/entity/saleSummary.model';
import {WorkflowTaskSummaryModel} from '../../../../../workflow/task/api/model/common/workflowTaskSummary.model';

export class PurchaseOrderModel {
    summary: PurchaseOrderSummaryModel;
    sale: SaleSummaryModel;
    emailWorkflowTasks: WorkflowTaskSummaryModel[] = [];
}
